<template lang="">
    <div
        v-if="productPlan"
        class="product__item-grid-tile"
        :class="{ 'is-selected': orderSslState({ name: productPlan.name, domain: domain.domain }) }"
    >
        <div v-if="productPlan.marketing" class="product__item__grid-tile-highlight">
            {{ productPlan.marketing }}
        </div>
        <div class="product__item-grid-tile-header-ssl">
            <div class="product__item-grid-tile-header-green">
                <h3 class="gamma | product__item-grid-tile-title-green">{{ productPlan.name }}</h3>
                <price-display :price="productPrice" />
            </div>
            <p class="product__item-grid-tile-subtitle p--flush">{{ productPlan.description }}</p>
        </div>

        <div class="product__item-grid-tile-list | clearfix"></div>

        <div class="product__item-grid-tile-list | u-display--none-portable u-margin-bottom clearfix"></div>

        <div class="product__item-grid-tile-button">
            <div class="u-text-center">
                <button
                    :class="{
                        'btn--ghost': !orderSslState({ name: productPlan.name, domain: domain.domain }),
                        'btn--ghost-selected': orderSslState({ name: productPlan.name, domain: domain.domain })
                    }"
                    @click="
                        switchSsl({
                            name: productPlan.name,
                            domain: domain.domain,
                            status: displayPriceType,
                            price: productPrice,
                            gross_price: grossProductPrice,
                            period: defaultPeriod
                        })
                    "
                    type="button"
                    dusk="add-ssl-button"
                    class="btn | u-full-width"
                >
                    <span v-if="!orderSslState({ name: productPlan.name, domain: domain.domain })">{{
                        trans('order.select')
                    }}</span>
                    <span v-else>{{ trans('order.chosen') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';
import productMixin from '../../mixins/product.js';

export default {
    components: {
        PriceDisplay
    },
    mixins: [productMixin],
    props: {
        domain: {
            type: Object,
            required: true,
            default: () => {}
        },
        productPlan: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: 'ssl'
        };
    },
    computed: {
        ...mapGetters({
            productPlans: 'products/productPlans',
            orderSslState: 'order/sslState'
        })
    },
    methods: {
        ...mapActions({
            switchSsl: 'order/switchSsl'
        })
    }
};
</script>
